<template>
    <el-form :model="vo">
        <div :class="wfEngineUrl ? 'el-table el-table--fit' : 'el-table el-table--fit el-table--border'" style="100%">
            <div class="el-table__body-wrapper">
                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body el-table__body-no">
                    <tbody>
                        <tr>
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'fileTitle'" moduleCode="common">文件标题</span>
                            </td>
                            <td class="el-table__cell tdcont tdw83" colspan="3">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="文件标题" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-input v-if="canEdit" v-model="vo.flSubject" :placeholder="$tx('gwgl.common.fileTitlePlaceholder', '请输入文件标题')" />
                                        <span v-else v-text="vo.flSubject" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                        </tr>
                        <tr>
                            <td v-field-lbl="'flContent'" class="el-table__cell tdlbl tdw17">摘要</td>
                            <td class="el-table__cell tdcont tdw83" colspan="3">
                                <el-input v-if="canEdit" v-model="vo.flContent" type="textarea" show-word-limit :placeholder="$tx('gwgl.gdgl.abstractPlaceholder', '请输入摘要')" />
                                <span v-else v-text="vo.flContent" />
                            </td>
                        </tr>
                        <tr v-show="chooseFlGwType !== '会议通知' && !wflowform">
                            <td v-field-lbl="'fileName'" class="el-table__cell tdlbl tdw17">文件正文</td>
                            <td class="el-table__cell tdcont tdw83" colspan="3">
                                <form-item
                                    ref="fileData"
                                    :field="{
                                        defaultValue: 'fileName',
                                        elementCanEdit: '{{canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: null,
                                        elementType: 'file',
                                        emptyMessage: $tx('gwgl.gdgl.fileZwEmptyMessage', '请选择文件正文'),
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '文件正文',
                                        propName: 'fileData',
                                        propType: 'byte[]',
                                        textFormatter: '.doc, .docx, .pdf',
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        model: 'vo.fileData',
                                        option: [],
                                        downloadUrl: '',
                                        nameField: 'fileName',
                                        limitCount: null
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'gwType'">公文种类</span>
                            </td>
                            <td :class="chooseFlGwType !== '收文阅办' && chooseFlGwType !== '文件传阅' ? 'tdcont tdw83' : 'tdcont tdw33'" :colspan="chooseFlGwType !== '收文阅办' && chooseFlGwType !== '文件传阅' ? 3 : 1" class="el-table__cell">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="公文种类" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-select v-if="canEdit" v-model="vo.flGwType" :placeholder="$tx('gwgl.gdgl.gwTypePlaceholder', '请输入公文种类')" style="width: 100%" @change="flGwTypeChange">
                                            <el-option v-for="(item, index) in vo.passenger.flGwTypeOptions" :key="index" :label="item.name" :value="item.name" />
                                        </el-select>
                                        <span v-else v-text="vo.flGwType" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <template v-if="chooseFlGwType === '收文阅办' || chooseFlGwType === '文件传阅'">
                                <td class="el-table__cell tdlbl tdw17">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'swCode'">收文编号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33">
                                    <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="收文编号" rules="required">
                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                            <el-input v-if="canEdit" v-model="vo.flSwzh" :placeholder="$tx('gwgl.gdgl.swCodePlaceholder', '请输入收文编号')" />
                                            <span v-else v-text="vo.flSwzh" />
                                        </el-tooltip>
                                    </ValidationProvider>
                                </td>
                            </template>
                            <td v-if="chooseFlGwType === '会议通知'" class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'startTime'">会议开始时间</span>
                            </td>
                            <td v-if="chooseFlGwType === '会议通知'" class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="会议开始时间" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-date-picker v-if="canEdit" v-model="vo.startTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" :placeholder="$tx('gwgl.gdgl.meetingStartTimePlaceholder', '请选择会议开始时间')" />
                                        <span v-else v-text="timeTranslate(vo.startTime)" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <!-- <td v-if="chooseFlGwType === '单位发文' || chooseFlGwType === '部门便函' || chooseFlGwType === '意见征集' || chooseFlGwType === '请示报告'" colspan="2" /> -->
                        </tr>
                        <tr>
                            <td v-if="chooseFlGwType === '单位发文' || chooseFlGwType === '请示报告'" class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'flCreateDate'">拟稿日期</span>
                            </td>
                            <td v-if="chooseFlGwType === '单位发文' || chooseFlGwType === '请示报告'" class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="拟稿日期" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-date-picker v-if="canEdit" v-model="vo.flCreateDate" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" style="width: 100%" :placeholder="$tx('gwgl.gdgl.draftDatePlaceholder', '请选择成文日期')" />
                                        <span v-else v-text="dateTranslate(vo.flCreateDate)" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <td v-if="chooseFlGwType === '会议通知'" class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'callDate'">召集日期</span>
                            </td>
                            <td v-if="chooseFlGwType === '会议通知'" class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="召集日期" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-date-picker v-if="canEdit" v-model="vo.flCreateDate" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" style="width: 100%" :placeholder="$tx('gwgl.gdgl.callDatePlaceholder', '请选择召集日期')" />
                                        <span v-else v-text="dateTranslate(vo.flCreateDate)" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <td v-if="chooseFlGwType === '会议通知'" class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'endTime'">会议结束时间</span>
                            </td>
                            <td v-if="chooseFlGwType === '会议通知'" class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="会议结束时间" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-date-picker v-if="canEdit" v-model="vo.endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" :placeholder="$tx('gwgl.gdgl.meetingEndTimePlaceholder', '会议结束时间')" />
                                        <span v-else v-text="timeTranslate(vo.endTime)" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <td v-if="chooseFlGwType === '收文阅办' || chooseFlGwType === '部门收文' || chooseFlGwType === '文件传阅'" class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'flLwrq'">来文日期</span>
                            </td>
                            <td v-if="chooseFlGwType === '部门便函' || chooseFlGwType === '意见征集'" class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'flCreateDate'">创建日期</span>
                            </td>
                            <td v-if="chooseFlGwType === '收文阅办' || chooseFlGwType === '部门收文' || chooseFlGwType === '文件传阅'" class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="来文日期" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-date-picker v-if="canEdit" v-model="vo.flLwrq" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" style="width: 100%" :placeholder="$tx('gwgl.gdgl.submissionDatePlaceholder', '请选择来文日期')" />
                                        <span v-else v-text="dateTranslate(vo.flLwrq)" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <td v-if="chooseFlGwType === '部门便函' || chooseFlGwType === '意见征集'" class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="创建日期" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-date-picker v-if="canEdit" v-model="vo.flCreateDate" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" style="width: 100%" :placeholder="$tx('gwgl.gdgl.createTimePlaceholder', '请选择创建日期')" />
                                        <span v-else v-text="dateTranslate(vo.flCreateDate)" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <td v-if="chooseFlGwType === '单位发文'" class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'flGrade'">文件字号</span>
                            </td>
                            <td v-if="chooseFlGwType === '单位发文'" class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="文件字号" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-input v-if="canEdit" v-model="vo.flGrade" :placeholder="$tx('gwgl.gdgl.documentSizePlaceholder', '请填写文件字号')" />
                                        <span v-else v-html="vo.flGrade" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <td v-if="chooseFlGwType === '收文阅办' || chooseFlGwType === '部门收文' || chooseFlGwType === '文件传阅'" class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-if="chooseFlGwType === '收文阅办' || chooseFlGwType === '部门收文'" v-field-lbl="'documentType'">来文字号</span>
                                <span v-if="chooseFlGwType === '文件传阅'" v-field-lbl="'documentCode'">来文编号</span>
                            </td>
                            <td v-if="chooseFlGwType === '收文阅办' || chooseFlGwType === '部门收文' || chooseFlGwType === '文件传阅'" class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" :name="chooseFlGwType === '收文阅办' || chooseFlGwType === '部门收文' ? $tx('gwgl.gdgl.documentType') : $tx('gwgl.gdgl.documentCode')" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-input v-if="canEdit" v-model="vo.flLwzh" :placeholder="$tx('gwgl.gdgl.flLwzhPlaceholder', { font: chooseFlGwType === '收文阅办' || chooseFlGwType === '部门收文' ? '字' : '编', size: '号' }, '请填写来文字号')" />
                                        <span v-else v-text="vo.flLwzh" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <td v-if="chooseFlGwType === '意见征集'" class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'replyTime'">回复时限</span>
                            </td>
                            <td v-if="chooseFlGwType === '意见征集'" class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="回复时限" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-date-picker v-if="canEdit" v-model="vo.replyTime" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" style="width: 100%" :placeholder="$tx('gwgl.gdgl.responseTimePlaceholder', '请选择回复时限')" />
                                        <span v-else v-text="dateTranslate(vo.replyTime)" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <td v-if="chooseFlGwType === '部门便函' || chooseFlGwType === '请示报告'" colspan="2" />
                        </tr>
                        <tr v-if="chooseFlGwType === '收文阅办' || chooseFlGwType === '部门收文' || chooseFlGwType === '文件传阅'">
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'flLwdw'">来文单位</span>
                            </td>
                            <td class="el-table__cell tdcont tdw83" colspan="3">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="来文单位" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-input v-if="canEdit" v-model="vo.flLwdw" :placeholder="$tx('gwgl.gdgl.reportingUnitPlaceholder', '请输入来文单位')" />
                                        <span v-else v-text="vo.flLwdw" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                        </tr>

                        <tr>
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'flSLevel'">密级</span>
                            </td>
                            <td class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="密级" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-select v-if="canEdit" v-model="vo.flSLevel" :placeholder="$tx('gwgl.gdgl.classificationPlaceholder', '请选择密级')" style="width: 100%">
                                            <el-option v-for="item in vo.passenger.flSLevelOptions" :key="item.value" :label="item.text" :value="item.value" />
                                        </el-select>
                                        <span v-else v-text="vo.flSLevel" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'gdType'">归档类型</span>
                            </td>
                            <td class="el-table__cell tdcont tdw33">
                                <!-- <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="归档类型" rules="required">
                  <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                    <el-select v-if="(canEdit)" v-model="vo.gdType" placeholder="请选择归档类型" style="width:100%">
                      <el-option
                        v-for="item in gdType"
                        :key="item.value"
                        :label="item.title"
                        :value="item.value"
                      />
                    </el-select>
                  </el-tooltip>
                </ValidationProvider> -->
                                <span v-text="gdTypeObj[vo.gdType]" />
                            </td>
                        </tr>
                        <tr>
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'creator'">归档人</span>
                            </td>
                            <td class="el-table__cell tdcont tdw33">
                                {{ vo.creator }}
                            </td>
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'gdTime'">归档日期</span>
                            </td>
                            <td class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="归档日期" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-date-picker v-if="canEdit" v-model="vo.gdTime" :placeholder="$tx('gwgl.gdgl.filingDatePlaceholder', '请选择归档日期')" type="date" format="yyyy年MM月dd日" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
                                        <span v-else v-text="dateTranslate(vo.gdTime)" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                        </tr>

                        <tr v-if="vo.isnew">
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'categoryName'">归档分类管理</span>
                            </td>
                            <td class="el-table__cell tdcont tdw33">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="分类" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-input v-if="canEdit" ref="gdTypeTree" v-model="vo.categoryName" v-select-dialog="'gdtype'" readonly :init-tree-data="treeData" style="width: 100%" :dialog-title="$tx('gwgl.components.archiveClassificationSelect', '选择归档分类')" :multiple="false" :placeholder="$tx('gwgl.components.archiveClassificationPlaceholder')" name="" />
                                        <span v-else v-text="vo.categoryName" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'flELevel'">紧急程度</span>
                            </td>
                            <td class="el-table__cell tdcont tdw33">
                                <form-item
                                    ref="flELevel"
                                    :field="{
                                        cssClass: null,
                                        cssStyle: null,
                                        defaultValue: '',
                                        elementCanEdit: '{{curTN.tnCanEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '：',
                                        elementReadonly: null,
                                        elementType: 'select',
                                        emptyMessage: $tx('gwgl.gdgl.urgencyEmptyMessage', '请选择紧急程度'),
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onBlurEvent: null,
                                        onChangeEvent: null,
                                        onClickEvent: null,
                                        onDblClickEvent: null,
                                        onFocusEvent: null,
                                        onKeyDownEvent: null,
                                        onKeyPressEvent: null,
                                        onKeyUpEvent: null,
                                        onMouseDownEvent: null,
                                        onMouseOverEvent: null,
                                        onMouseUpEvent: null,
                                        passenger: {},
                                        propComment: '紧急程度 ',
                                        propName: 'flELevel',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.flELevel',
                                        option: [{ name: '', value: '' }],
                                        optionGenerateType: 0
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                        </tr>

                        <tr v-if="chooseFlGwType === '会议通知'">
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'address'">会议地点</span>
                            </td>
                            <td class="el-table__cell tdcont tdw33" colspan="3">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="会议地点" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-input v-if="canEdit" v-model="vo.address" :placeholder="$tx('gwgl.gdgl.meetingAddressPlaceholder', '请输入会议地点')" />
                                        <span v-else v-text="vo.address" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                        </tr>
                        <tr>
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'accessRightsType'" moduleCode="components">文件查阅权限</span>
                            </td>
                            <td colspan="3" class="el-table__cell tdcont tdw83">
                                <el-radio-group v-model="vo.accessRightsType" :disabled="!canEdit">
                                    <el-radio v-text-lbl="'allPersonnel'" :label="0" module-code="components">全体人员可阅</el-radio>
                                    <el-radio v-if="vo.busiDataId && wfEngineUrl !== 'gwgl/gdwj'" v-text-lbl="'originalHandler'" :label="1" module-code="components">原经办人可阅</el-radio>
                                    <el-radio v-if="vo.busiDataId && wfEngineUrl !== 'gwgl/gdwj'" v-text-lbl="'handlerDesignated'" :label="2" module-code="components">原经办人+指定人可阅</el-radio>
                                    <el-radio v-if="!vo.busiDataId || wfEngineUrl === 'gwgl/gdwj'" v-text-lbl="'designatedReaders'" :label="2" module-code="components">指定可阅人</el-radio>
                                </el-radio-group>
                            </td>
                        </tr>
                        <tr v-if="vo.accessRightsType === 2">
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-field-lbl="'appoints'" moduleCode="components">指定类型</span>
                            </td>
                            <td colspan="3" class="el-table__cell tdcont tdw83">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="指定类型" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-radio-group v-model="vo.appoints" :disabled="!canEdit" @change="changAppoints">
                                            <el-radio v-text-lbl="'specifyGroup'" :label="'1'" module-code="components">指定群组</el-radio>
                                            <el-radio v-text-lbl="'specifyDepart'" :label="'2'" module-code="components">指定部门</el-radio>
                                            <el-radio v-text-lbl="'specifyPerson'" :label="'3'" module-code="components">指定人员</el-radio>
                                        </el-radio-group>
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                        </tr>
                        <tr v-if="vo.accessRightsType === 2 && vo.appoints !== '' && vo.appoints !== null">
                            <td class="el-table__cell tdlbl tdw17">
                                <span class="required">*</span>
                                <span v-if="vo.appoints === '1'" v-text-lbl="'selectGroup'" moduleCode="components">选择群组</span>
                                <span v-if="vo.appoints === '2'" v-text-lbl="'selectDepart'" moduleCode="components">选择部门</span>
                                <span v-if="vo.appoints === '3'" v-text-lbl="'selectPerson'" moduleCode="components">选择人员</span>
                            </td>
                            <td colspan="3" class="el-table__cell tdcont tdw83">
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="群组" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-input v-show="vo.appoints === '1'" v-model="vo.deptOrName" v-can-edit v-select-dialog="'workgroup'" :placeholder="$tx('gwgl.components.GroupPlaceholder', '请选择群组')" readonly="readonly" multiple="true" type="textarea" :root-org-code="vo.orgCode" name="deptIds2" />
                                    </el-tooltip>
                                </ValidationProvider>
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="部门" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-input v-show="vo.appoints === '2'" v-model="vo.deptOrName" v-can-edit v-select-dialog="'suborg'" :placeholder="$tx('gwgl.components.DepartPlaceholder', '请选择部门')" org-level="2" readonly="readonly" multiple="true" type="textarea" :root-org-code="vo.orgCode" name="deptIds" />
                                    </el-tooltip>
                                </ValidationProvider>
                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="人员" rules="required">
                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                        <el-input v-show="vo.appoints === '3'" v-model="vo.deptOrName" v-can-edit v-select-dialog="'staff'" :placeholder="$tx('gwgl.components.PersonPlaceholder', '请选择人员')" readonly="readonly" multiple="true" type="textarea" name="deptIds" :root-org-code="vo.orgCode" />
                                    </el-tooltip>
                                </ValidationProvider>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </el-form>
</template>

<script>
const moment = require('moment')
export default {
    components: {},
    props: {
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 }
    },
    data() {
        return {
            i18npkg: 'gwgl',
            moduleCode: 'gdgl',
            gwType: [
                { title: '单位发文', value: '单位发文' },
                { title: '收文阅办', value: '收文阅办' },
                { title: '部门收文', value: '部门收文' },
                { title: '文件传阅', value: '文件传阅' },
                { title: '部门便函', value: '部门便函' },
                { title: '意见征集', value: '意见征集' },
                { title: '会议通知', value: '会议通知' },
                { title: '请示报告', value: '请示报告' }
            ],
            security: [
                { title: '一般', value: '1' },
                { title: '特殊', value: '2' }
            ],
            // gdType: [{ title: '电子归档', value: 1 }, { title: '纸质归档', value: 2 }],
            // gdTypeObj: { 1: '电子归档', 2: '纸质归档' },
            gdType: [
                { title: this.$tx('gwgl.components.electronicFilling', '电子归档'), value: 1 },
                { title: this.$tx('gwgl.components.paperArchiving', '纸质归档'), value: 2 }
            ],
            gdTypeObj: { 1: this.$tx('gwgl.components.electronicFilling', '电子归档'), 2: this.$tx('gwgl.components.paperArchiving', '纸质归档') },

            root: [],
            treeData: [],
            loginUser: null,
            chooseFlGwType: null,
            wflowform: false,
            wfEngineUrl: ''
        }
    },
    computed: {
        dateTranslate() {
            return (time) => {
                if (time) {
                    return moment(time).format('YYYY年MM月DD日')
                } else {
                    return ''
                }
            }
        },
        timeTranslate() {
            return (time) => {
                if (time) {
                    return moment(time).format('YYYY-MM-DD HH:mm')
                } else {
                    return ''
                }
            }
        }
    },
    watch: {
        'vo.flGwType'(a) {
            const list = this.vo.passenger.flGwTypeOptions.filter((item) => item.name === a)[0]
            if (list !== undefined) {
                this.chooseFlGwType = list.fileType
            }
            // this.vo.wfNodeNames = list.wfEngineUrl
        }
    },
    created() {
        const list = this.vo.passenger.flGwTypeOptions.filter((item) => item.name === this.vo.flGwType)[0]
        if (list !== undefined) {
            this.chooseFlGwType = list.fileType
        }
        this.loginUser = this.$store.getters.loginUser

        if (location.href.indexOf('/wflow') !== -1) {
            this.canEdit = 0
            this.wflowform = true
        }
        this.wfEngineUrl = this.$route.query.wfEngineUrl
        this.queryData()
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        onWflowFormOpened() {},
        onWflowFormBeforeSubmit() {},
        onWflowFormSubmited() {},
        queryData() {
            // 加载类型节点数据
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: { orderBy: 'categoryLevel asc,orderno asc' },
                data: [{ compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode }],
                url: '/gwgl/gdflsz/querydata'
            }).then((res) => {
                if (res.code === 'success') {
                    this.treeData = this.treeData = this.treeDataAdapter(this.root.concat(res.body.listdata))
                    console.log(this.treeData, 'gwgl')
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        treeDataAdapter(treeData) {
            treeData.forEach((node) => {
                if (node.parentId === null || node.parentId === '' || node.parentId === undefined) {
                    node.pId = '1'
                } else {
                    node.pId = node.parentId
                }
                node.name = node.categoryName
                node.title = node.categoryName
            })
            // treeData格式必须遵循ztreeview treeNode规范
            return treeData
        },
        onGdtypeCompleted(selectedNodes, attr) {
            this.vo.categoryName = selectedNodes[0].name
            this.vo.categoryId = selectedNodes[0].categoryFullId
        },
        // 选择部门、科室、班组
        onSelectSuborgCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += '、'
                if (selected !== '') selectCode += '、'
                selected += node.name
                selectCode += node.id
            })
            this.$set(this.vo, 'deptIds', selectCode)
            this.$set(this.vo, 'deptOrName', selected)
        },
        // 选择工作群组
        onSelectWorkgroupCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += '、'
                if (selected !== '') selectCode += '、'
                selected += node.name
                selectCode += node.id
            })
            this.$set(this.vo, 'deptIds', selectCode)
            this.$set(this.vo, 'deptOrName', selected)
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selectCode += '、'
                if (selected !== '') selected += '、'
                selected += node.name
                selectCode += node.personId
            })

            this.$set(this.vo, 'deptOrName', selected)
            this.$set(this.vo, 'deptIds', selectCode)
        },
        // 切换选项清空
        changAppoints(value) {
            this.vo.deptIds = ''
            this.vo.deptOrName = ''
            if (value === this.activeId) {
                this.vo.deptIds = this.activedeptIds
                this.vo.deptOrName = this.activeText
            }
        },
        flGwTypeChange() {
            this.vo.number = ''
        },
        // 清除查阅权限
        clearAccessRightsType() {
            this.vo.accessRightsType = null
            this.vo.appoints = null
            this.vo.deptOrName = ''
            this.vo.deptIds = ''
        }
    }
}
</script>

<style scoped lang="scss">
.el-table__body {
    &.el-table__body-no {
        table-layout: auto;
    }
}
/deep/.upload-list {
    width: 100%;
    .el-upload {
        width: 100%;
    }
}
/deep/ .el-divider--horizontal {
    margin: 10px 0;
}
</style>
